<template>
    <h1>HealthProfile</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/HealthProfile.vue